export default __webpack_public_path__ + "static/costume_m_veste-df930c112e0fa15415b3fae2d6e4c33c.png";